/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import {
	Container,
	Content,
	ContentResultSearchStudentById,
	Fields,
	Footer,
	AddStudentField,
} from "views/components/AttendanceList/styles";
import { Paragraph, ReminderMessage } from "./styles";
//#endregion
//#region Components
import BackToView from "components/BackToView/BackToView";
import CustomTextInput from "components/CustomTextInput/CustomTextInput";
import CustomButton from "components/CustomButton/CustomButton";
import CustomTableList from "components/CustomTableList/CustomTableList";
import Preloader from "components/Preloader/Preloader";
import ToastMessage from "components/ToastMessage/ToastMessage";
import HelmetUTP from "components/HelmetUTP/HelmetUTP";
import DialogAlertSuccessNotify from "components/DialogAlertNotify/DialogAlertSuccessNotify/DialogAlertSuccessNotify";
import TakeTutorAttendancePanel from "./components/TakeTutorAttendancePanel";
import ListItem from "./components/ListItem/ListItem";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import CustomSearchInput from "components/CustomSearchInput/CustomSearchInput";
import { CustomCheckbox } from "components/CustomCheckbox/CustomCheckbox";
import DialogAlertErrorNotify from "components/DialogAlertNotify/DialogAlertErrorNotify/DialogAlertErrorNotify";
import HeaderComponent from "./components/HeaderComponent/HeaderComponent";
//#endregion
//#region Images
import errorWindow from "img/error_window.svg";
import infoIcon from "img/info_icon.svg";
//#endregion
//#region Services
import { requestGetNameStudentById } from "services/general";
import {
	requestGetStudentsAcadReinforceReservation,
	requestAddStudentToAcadReinforceReservation,
	requestSaveAcadReinforceAttendanceStudent,
	requestGetInfoTutorAttendance,
	requestTakeTutorAttendance,
} from "services/acadReinforce/attendance";
import { acadReinforcementSessionStorage } from "services/storage/acadReinforcement";
//#endregion
//#region Utils
import { ACAD_REINFORCE_CONSTANTS } from "config/constants";
import useMainContext from "utils/context/useMainContext";
import { handlerKeyPressOnlyNumbersAndLetters } from "utils/validations";
import { useNavigatingAway } from "utils/hooks/usePrompt";
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
import useToastMessage from "components/ToastMessage/utils/hooks/useToastMessage";
import {
	DIALOGS_ALERT_CHECKTIME,
	HEADERS_TABLE_LIST,
	INIT_INFO_TUTOR_ATTENDANCE,
	PROPS_CONTENT_DIALOG_ALERT_NOTIFY_NOT_CHECKED_TIME_TO_STUDENT_ATTENDANCE,
} from "./utils/constants";
import useLoadingRequest from "components/Preloader/utils/hooks/useLoadingRequest";
//#endregion

const { ADD_STUDENT_TO_ACAD_REINFORCE_RESERVATION_MESSAGES } =
	ACAD_REINFORCE_CONSTANTS;

const AcadReinforceAttendanceComponent = () => {
	//#region Extra
	const navigate = useNavigate();
	const $content = useRef();
	const mainContext = useMainContext();
	//#endregion
	//#region States
	const [dataAcadReinforce, setDataAcadReinforce] = useState(null);
	const [searchStudent, setSearchStudent] = useState("");
	const [studentsFoundList, setFoundStudentList] = useState([]);
	const [studentToAdd, setStudentToAdd] = useState({
		id: "",
		toastId: "",
		name: "",
	});
	const [attendanceAllStudents, setAttendaceAllStudents] = useState(false);
	const [studentsReservation, setStudentsReservation] = useState([]);
	const [copyStudentsReservation, setCopyStudentsReservation] = useState([]);
	const [studentPinId, setStudentPinId] = useState(null);
	const [
		showDialogResultSearchStudentById,
		setShowDialogResultSearchStudentById,
	] = useState(false);
	const loadingRequest = useLoadingRequest();
	const [errorSaveAttendance, setErrorSaveAttendance] = useState(false);
	const [
		hiddenToastSuccessAddReservation,
		setHiddenToastSuccessAddReservation,
	] = useState(true);
	const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
		useState(false);
	const [showDialogCheckInTimeQuestion, setShowDialogCheckInTimeQuestion] =
		useState(false);
	const [showDialogCheckOutTimeQuestion, setShowDialogCheckOutTimeQuestion] =
		useState(false);
	const [
		showDialogNotifyNotCheckedOutTimeToStudentAttendance,
		setShowDialogNotifyNotCheckedOutTimeToStudentAttendance,
	] = useState(false);
	const [showDialogSaveAttendance, setShowDialogSaveAttendance] =
		useState(false);
	const [serverTime, setServerTime] = useState("-");
	const [infoTutorAttendance, setInfoTutorAttendance] = useState({
		...INIT_INFO_TUTOR_ATTENDANCE,
	});
	//#endregion
	const toastErrorMessageSaveAttendance = useToastMessage();
	//#region Effects
	useEffect(() => {
		fillDataAcadReinforce();
	}, []);
	useEffect(() => {
		if (!dataAcadReinforce) return;
		fillStudentsReservation();
		if (!dataAcadReinforce.isPresential) return;
		fillInfoTutorAttendance();
	}, [dataAcadReinforce]);
	useEffect(() => {
		setAttendaceAllStudents(
			studentsReservation.length > 0 &&
			studentsReservation.every(({ attendance }) => attendance)
		);
	}, [studentsReservation]);
	//#endregion
	//#region Manejo de salida de vista
	const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
		useNavigatingAway(canShowDialogLeavingPage);
	//#endregion
	//#region Functions
	const fillStudentsReservation = async () => {
		loadingRequest.show();
		// Recuperando las reservas de los estudiantes
		const fetchStudentReservation =
			await requestGetStudentsAcadReinforceReservation();
		setStudentsReservation([...fetchStudentReservation]);
		setCopyStudentsReservation([...fetchStudentReservation]);
		loadingRequest.hide();
	};
	const fillInfoTutorAttendance = async () => {
		loadingRequest.show();
		// Recuperando información de la asistencia del tutor
		const infoTutorAttendance = await requestGetInfoTutorAttendance(
			dataAcadReinforce.id
		);
		loadingRequest.hide();
		if (infoTutorAttendance) setInfoTutorAttendance(infoTutorAttendance);
		else mainContext.setShowDialogUnexpectedError(true);
	};
	const fillDataAcadReinforce = () => {
		const data =
			acadReinforcementSessionStorage.acadReinforceDataToAttendance.get();
		setDataAcadReinforce(data);
	};
	const navigateToAcadReinforce = () => {
		navigate(ABSOLUTE_PATHS.ACAD_REINFORCE_LIST);
	};
	const toAcadReinforceList = () => {
		setTimeout(() => {
			navigateToAcadReinforce();
		}, 380);
	};
	const toggleShowDialogSaveAttendance = (value = null) => {
		setShowDialogSaveAttendance(prev => (value === null ? !prev : value));
	};
	const toggleShowDialogResultSearchById = (value = null) => {
		setShowDialogResultSearchStudentById(prev =>
			value !== null ? value : !prev
		);
	};
	const toggleShowDialogCheckInTimeQuestion = (value = null) => {
		setShowDialogCheckInTimeQuestion(prev =>
			value !== null ? value : !prev
		);
	};
	const toggleShowDialogCheckOutTimeQuestion = (value = null) => {
		setShowDialogCheckOutTimeQuestion(prev =>
			value !== null ? value : !prev
		);
	};
	const toggleShowDialogNotifyNotCheckedOutTimeToStudentAttendance = (
		value = null
	) => {
		setShowDialogNotifyNotCheckedOutTimeToStudentAttendance(prev =>
			value !== null ? value : !prev
		);
	};
	const changeStudentToAdd = id => {
		id = id.toUpperCase();
		setStudentToAdd({
			...studentToAdd,
			id: id,
			name: "",
		});
	};
	const changeSearchStudent = value => {
		clearFoundStudentList();
		setSearchStudent(value);
		if (!value) return;
		setFoundStudentList(
			studentsReservation
				.filter(({ name }) => {
					if (!name) 
						return false;
					return name
						.toUpperCase()
						.includes(value.toUpperCase().trim());
				})
				.map(({ id, name: text }) => {
					return {
						id,
						text,
					};
				})
		);
	};
	const clearFoundStudentList = () => {
		setFoundStudentList([]);
	};
	const selectSearchStudent = ({ id }) => {
		clearFoundStudentList();
		const foundStudent = studentsReservation.find(
			({ id: currentId }) => currentId === id
		);
		const filterStudentsReservation = studentsReservation.filter(
			({ id }) => {
				return id !== foundStudent.id;
			}
		);
		filterStudentsReservation.unshift(foundStudent);
		// Realizando scroll de la tabla
		$content.current.querySelector("table").parentElement.scrollTo({
			top: 0,
			behavior: "smooth",
		});
		// Estableciendo pin del estudiante buscado
		setStudentPinId(id);
		setStudentsReservation(filterStudentsReservation);
		setTimeout(() => {
			setStudentPinId(null);
		}, 1000);
	};
	const clearStudentIdToAdd = () => {
		setStudentToAdd({
			...studentToAdd,
			id: "",
		});
	};
	const addStudentToStudentsReservation = async () => {
		toggleShowDialogResultSearchById();
		loadingRequest.show("Agregando alumno...");
		const { success, message } =
			await requestAddStudentToAcadReinforceReservation({
				studentId: studentToAdd.id,
				acadReinforceId: dataAcadReinforce.id,
			});
		try {
			switch (message) {
				case ADD_STUDENT_TO_ACAD_REINFORCE_RESERVATION_MESSAGES.VACANCY_LIMIT:
					clearStudentIdToAdd();
					toastErrorMessageSaveAttendance.show(
						"Se ha alcanzado el límite de vacantes.",
						null,
						2400
					);
					return;
				default:
					break;
			}
			if (!success) {
				mainContext.setShowDialogUnexpectedError(true);
				return;
			}
			await fillStudentsReservation();
		} finally {
			loadingRequest.hide();
		}
		// Mostrando mensaje de alumno agregado con éxito
		clearStudentIdToAdd();
		setHiddenToastSuccessAddReservation(false);
		setTimeout(() => {
			setHiddenToastSuccessAddReservation(true);
		}, 2400);
	};
	const studentExistsInReservationList = () => {
		if (
			studentsReservation.some(({ id }) => {
				return id === studentToAdd.id.trim();
			})
		) {
			clearStudentIdToAdd();
			toastErrorMessageSaveAttendance.show(
				"El alumno que intentas agregar ya se encuentra en la lista",
				null,
				2400
			);
			return true;
		}
		return false;
	};
	const searchStudentById = async () => {
		if (studentExistsInReservationList()) return;
		loadingRequest.show("Buscando alumno...");
		setStudentToAdd({
			...studentToAdd,
			name: "",
		});
		const nameStudent = await requestGetNameStudentById(studentToAdd.id);
		if (nameStudent)
			setStudentToAdd({
				...studentToAdd,
				toastId: studentToAdd.id,
				name: nameStudent,
			});
		loadingRequest.hide();
		toggleShowDialogResultSearchById();
	};
	const changeAttendanceStutentReservation = id => {
		const newStudentsReservation = studentsReservation.map(student => {
			return student.id === id
				? {
					...student,
					attendance: !student.attendance,
				}
				: student;
		});
		setErrorSaveAttendance(false);
		setStudentsReservation(newStudentsReservation);
		// Habilitando aviso de salida sin guardar
		setCanShowDialogLeavingPage(true);
	};
	const changeAttendanceAllStudents = () => {
		if (attendanceAllStudents) {
			setStudentsReservation(
				studentsReservation.map(student => ({
					...student,
					attendance: false,
				}))
			);
			return;
		}
		setStudentsReservation(
			studentsReservation.map(student => ({
				...student,
				attendance: true,
			}))
		);
		// Habilitando aviso de salida sin guardar
		setCanShowDialogLeavingPage(true);
	};
	async function doRequestSaveAttendance() {
		loadingRequest.show("Guardando asistencia...");
		try {
			const response = await requestSaveAcadReinforceAttendanceStudent(studentsReservation);
			if (!response.success) {
				// Mostrar el mensaje de error del backend
				toastErrorMessageSaveAttendance.show(response.message || "Ocurrió un error al guardar la asistencia.");
				setTimeout(() => {
					toastErrorMessageSaveAttendance.hide();
				}, 2400);
				return response; // Devuelve la respuesta para que saveAttendance pueda manejarla
			}
			return response; // Devuelve la respuesta exitosa
		} catch (error) {
			// Manejo de errores inesperados
			toastErrorMessageSaveAttendance.show("Error inesperado al guardar la asistencia.");
			setTimeout(() => {
				toastErrorMessageSaveAttendance.hide();
			}, 2400);
			return null; // Devuelve null en caso de error inesperado
		} finally {
			loadingRequest.hide();
		}
	}
	const saveAttendance = async () => {
		const anyCheckedStudentsReservation = studentsReservation.every(
			({ attendance }) => !attendance
		);
		if (anyCheckedStudentsReservation) {
			setErrorSaveAttendance(true);
			// Mostrando mensaje de error al agregar porque el estudiante ya existe
			toastErrorMessageSaveAttendance.show(
				"Tienes que agregar asistencia para pasar al siguiente paso.",
				null,
				2400
			);
			return;
		}
		
		const response = await doRequestSaveAttendance();
		if (response?.success) {
			// Deshabilitando aviso de salida sin guardar
			setCanShowDialogLeavingPage(false);
			toggleShowDialogSaveAttendance();
		}
		await fillStudentsReservation();
	};
	const checkIfAttendanceWasTaken = () => {
		if(copyStudentsReservation.length == 0){
			return true;
		};

		const wasTaken = copyStudentsReservation.some(
			({ attendance }) => attendance
		);
		
		if (!wasTaken)
			setShowDialogNotifyNotCheckedOutTimeToStudentAttendance(true);
		return wasTaken;
	};
	const takeTutorAttendance = async (isCheckIn = false) => {
		loadingRequest.show("Tomando asistencia...");
		const success = await requestTakeTutorAttendance({
			acadReinforceId: dataAcadReinforce.id,
			isCheckIn: isCheckIn,
		});
		loadingRequest.hide();
		if (!success) {
			mainContext.setShowDialogUnexpectedError(true);
			return;
		}
		fillInfoTutorAttendance();
	};
	const renderDialogsAlertCheckTime = () => {
		return (
			<>
				<DialogAlertAction
					minWidth={DIALOGS_ALERT_CHECKTIME.minWidth}
					show={showDialogCheckInTimeQuestion}
					toggleShow={toggleShowDialogCheckInTimeQuestion}
					title="Marcar entrada"
					contentComponent={
						<Paragraph>
							¿Estás seguro que deseas marcar tu entrada a las{" "}
							{serverTime}?
						</Paragraph>
					}
				>
					<CustomButton
						{...DIALOGS_ALERT_CHECKTIME.buttonProps.ok}
						onClick={() => {
							toggleShowDialogCheckInTimeQuestion(false);
							takeTutorAttendance(true);
						}}
					/>
					<CustomButton
						{...DIALOGS_ALERT_CHECKTIME.buttonProps.cancel}
						onClick={() =>
							toggleShowDialogCheckInTimeQuestion(false)
						}
					/>
				</DialogAlertAction>
				<DialogAlertAction
					minWidth="560px"
					show={showDialogCheckOutTimeQuestion}
					toggleShow={toggleShowDialogCheckOutTimeQuestion}
					title="Marcar salida"
					contentComponent={
						<Paragraph>
							¿Estás seguro que deseas marcar tu salida a las{" "}
							{serverTime}?
						</Paragraph>
					}
				>
					<CustomButton
						{...DIALOGS_ALERT_CHECKTIME.buttonProps.ok}
						onClick={() => {
							toggleShowDialogCheckOutTimeQuestion(false);
							takeTutorAttendance();
						}}
					/>
					<CustomButton
						{...DIALOGS_ALERT_CHECKTIME.buttonProps.cancel}
						onClick={() =>
							toggleShowDialogCheckOutTimeQuestion(false)
						}
					/>
				</DialogAlertAction>
			</>
		);
	};
	//#endregion
	return (
		<Container>
			<HelmetUTP title="Ref. Acad. - Asistencia" />
			<ToastMessage
				hidden={hiddenToastSuccessAddReservation}
				message={`Agregaste al alumno ${studentToAdd.toastId}`}
			/>
			<ToastMessage
				{...toastErrorMessageSaveAttendance.value}
				variant="error"
			/>
			<BackToView
				text="Volver a refuerzos"
				to={ABSOLUTE_PATHS.ACAD_REINFORCE_LIST}
			/>
			{dataAcadReinforce?.isPresential && (
				<TakeTutorAttendancePanel
					{...infoTutorAttendance}
					setServerTime={setServerTime}
					loadingRequest={loadingRequest}
					checkIfAttendanceWasTaken={checkIfAttendanceWasTaken}
					showDialogCheckTime={{
						checkIn: {
							value: showDialogCheckInTimeQuestion,
							set: setShowDialogCheckInTimeQuestion,
						},
						checkOut: {
							value: showDialogCheckOutTimeQuestion,
							set: setShowDialogCheckOutTimeQuestion,
						},
					}}
					dateTime={dataAcadReinforce.dateTime}
				/>
			)}
			<Content ref={$content}>
				<HeaderComponent dataAcadReinforce={dataAcadReinforce} />
				<Fields>
					<CustomSearchInput
						dataFound={studentsFoundList}
						foundItemText={searchStudent}
						selectDataItem={selectSearchStudent}
						handlerItemSearched={changeSearchStudent}
						placeholder="Buscar un alumno en la lista"
						positionFoundBlock="absolute"
					/>
					{/* {dataAcadReinforce?.isPresential && (
						<AddStudentField>
							<CustomTextInput
								label="Agrega un alumno al listado"
								variant="secondary"
								placeholder="Añadir el código del alumno"
								value={studentToAdd.id}
								maxLength={9}
								onKeyPress={
									handlerKeyPressOnlyNumbersAndLetters
								}
								onChange={changeStudentToAdd}
							/>
							<CustomButton
								size="medium"
								width="120px"
								text="Buscar"
								disabled={
									studentToAdd.id.length < 7 ||
									studentToAdd.id.length > 9
								}
								onClick={searchStudentById}
							/>
						</AddStudentField>
					)} */}
				</Fields>
				<CustomTableList
					headers={HEADERS_TABLE_LIST.map((item, idx, { length }) => {
						return idx === length - 1
							? {
								...item,
								control: (
									<CustomCheckbox
										variant="box"
										disabled={
											!dataAcadReinforce?.isPresential
										}
										onChange={
											changeAttendanceAllStudents
										}
										checked={attendanceAllStudents}
										error={errorSaveAttendance}
									/>
								),
							}
							: item;
					})}
					minWidth="560px"
				>
					{studentsReservation.map((item, idx, { length }) => {
						const { id } = item;
						return (
							<ListItem
								key={idx}
								isPinned={id === studentPinId}
								disabled={!dataAcadReinforce?.isPresential}
								positionRow={
									idx === 0 ? 1 : idx === length - 1 ? -1 : 0
								}
								onlyOne={length === 1}
								changeAttendance={
									changeAttendanceStutentReservation
								}
								errorSaveAttendance={errorSaveAttendance}
								{...item}
							/>
						);
					})}
				</CustomTableList>
			</Content>
			<Footer>
				<CustomButton
					variant="terciary"
					text="Cancelar"
					onClick={() => navigate(ABSOLUTE_PATHS.ACAD_REINFORCE_LIST)}
				/>
				{dataAcadReinforce?.isPresential ? (
					<CustomButton
						disabled={studentsReservation.length === 0}
						text="Guardar asistencia"
						onClick={saveAttendance}
					/>
				) : (
					<CustomButton
						text="Cerrar"
						onClick={toAcadReinforceList}
					/>
				)}
			</Footer>
			<DialogAlertAction
				show={showDialogResultSearchStudentById}
				toggleShow={toggleShowDialogResultSearchById}
				contentComponent={
					<ContentResultSearchStudentById
						className={!studentToAdd.name ? "not-found" : ""}
					>
						{!studentToAdd.name && (
							<img
								className="not-found-image"
								src={errorWindow}
								alt="UTP imagen de no encontrado"
							/>
						)}
						<h3 className="title">Resultados de búsqueda</h3>
						<h5>
							Código agregado: <strong>{studentToAdd.id}</strong>
						</h5>
						{studentToAdd.name ? (
							<h3 className="description">
								Nombre de alumno: {studentToAdd.name}
							</h3>
						) : (
							<h3 className="description">
								El código agregado no existe
							</h3>
						)}
					</ContentResultSearchStudentById>
				}
				noImage={!studentToAdd.name}
			>
				{studentToAdd.name ? (
					<>
						<CustomButton
							size="medium"
							text="Agregar"
							onClick={addStudentToStudentsReservation}
						/>
						<CustomButton
							variant="secondary"
							size="medium"
							text="Cancelar"
							onClick={() => toggleShowDialogResultSearchById()}
						/>
					</>
				) : (
					<CustomButton
						text="Volver a intentarlo"
						width="200px"
						onClick={() => toggleShowDialogResultSearchById()}
					/>
				)}
			</DialogAlertAction>
			<DialogAlertAction
				minWidth="560px"
				show={showDialogLeavingPage}
				toggleShow={cancelNavigation}
				title="¿Deseas salir sin guardar la asistencia?"
				content="La asistencia tomada no se guardará"
			>
				<CustomButton
					variant="quintinary"
					text="Sí, salir"
					width="130px"
					onClick={confirmNavigation}
				/>
				<CustomButton
					variant="quaternary"
					text="No, continuar"
					width="130px"
					onClick={cancelNavigation}
				/>
			</DialogAlertAction>
			{renderDialogsAlertCheckTime()}
			<DialogAlertSuccessNotify
				variant="secondary"
				show={showDialogSaveAttendance}
				toggleShow={toggleShowDialogSaveAttendance}
				title="Asistencia de estudiantes guardada"
				contentComponent={
					<>
						<p>
							La asistencia de los estudiantes ha sido guardada
							correctamente.
						</p>
						{!infoTutorAttendance.checkInTime && (
							<ReminderMessage>
								<img
									src={infoIcon}
									alt="Ícono de información"
								/>
								<span>
									Recuerda que debes marcar tu hora de entrada
									y salida
								</span>
							</ReminderMessage>
						)}
					</>
				}
				buttons={
					<CustomButton
						text="Entendido"
						onClick={() => toggleShowDialogSaveAttendance(false)}
					/>
				}
			/>
			<DialogAlertErrorNotify
				show={showDialogNotifyNotCheckedOutTimeToStudentAttendance}
				toggleShow={
					toggleShowDialogNotifyNotCheckedOutTimeToStudentAttendance
				}
				content={
					PROPS_CONTENT_DIALOG_ALERT_NOTIFY_NOT_CHECKED_TIME_TO_STUDENT_ATTENDANCE
				}
			>
				<CustomButton
					text="Entendido"
					onClick={() =>
						toggleShowDialogNotifyNotCheckedOutTimeToStudentAttendance(
							false
						)
					}
				/>
			</DialogAlertErrorNotify>
			<Preloader {...loadingRequest.value} />
		</Container>
	);
};

export default AcadReinforceAttendanceComponent;
